export default __webpack_public_path__ + "media/avatars/11-44c343cd.png";